"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSearchCriterionFromOption = void 0;
/**
 * Helper method to generate a SearchCriterion from a SelectOptionHide.
 * @param option - The SelectOptionHide object.
 * @param isFixed - Whether the criterion is fixed (default: false).
 * @param isDisabled
 * @param searchTerm
 * @returns A SearchCriterion object.
 */
const generateSearchCriterionFromOption = (option, isFixed = false, isDisabled = false, searchTerm) => ({
    id: option.id,
    selectedOption: option,
    searchTerm: searchTerm !== null && searchTerm !== void 0 ? searchTerm : '',
    isFixed: isFixed,
    isDisabled: isDisabled,
});
exports.generateSearchCriterionFromOption = generateSearchCriterionFromOption;
